import { Button, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAppVersion,
  getAppVersionApi,
  saveAppVersionApi,
} from "../../actions/stations";
import Loader from "../../components/loader";
import { useShowToast } from "../../hooks";
import { strings } from "../../I18n";

const AppVersionTab = ({ whitelabel }) => {
  const dispatch = useDispatch();
  const showToast = useShowToast();

  const [iosVersion, setIosVersion] = useState("");
  const [androidVersion, setAndroidVersion] = useState("");
  const [deeplinkBaseurl, setDeeplinkBaseurl] = useState("");

  const appVersion = useSelector((state) => state.stations.appVersion);
  const appVersionSuccess = useSelector(
    (state) => state.stations.appVersionSuccess
  );
  const saveAppVersionSuccess = useSelector(
    (state) => state.stations.saveAppVersionSuccess
  );

  useEffect(() => {
    setAndroidVersion(appVersion?.androidVersion || "");
    setIosVersion(appVersion?.iosVersion || "");
    setDeeplinkBaseurl(appVersion?.deeplinkUrl || "");
  }, [appVersion]);

  useEffect(() => {
    refetchData();
  }, [saveAppVersionSuccess]);

  const clearData = () => {
    setAndroidVersion("");
    setIosVersion("");
    setDeeplinkBaseurl("");
  };

  const refetchData = () => {
    dispatch(getAppVersionApi(whitelabel));
  };

  useEffect(() => {
    clearData();
    refetchData();
  }, [whitelabel]);

  const saveInformation = () => {
    dispatch(
      saveAppVersionApi({
        code: whitelabel,
        androidVersion: androidVersion,
        iosVersion: iosVersion,
        deeplinkUrl: deeplinkBaseurl,
      })
    );
  };

  useEffect(() => {
    if (saveAppVersionSuccess === true) {
      dispatch(clearAppVersion());
      showToast("Success", "success");
    }
  }, [saveAppVersionSuccess]);

  if (appVersionSuccess === null) {
    return <Loader />;
  }

  return (
    <div style={{ marginTop: 20 }}>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td>
              <p>{strings("descriptions.iosVersion")}</p>
            </td>
            <td>
              <TextField
                id="ios-version"
                label={strings("descriptions.code")}
                type="text"
                value={iosVersion}
                onChange={(event) => setIosVersion(event.target.value)}
                margin="normal"
              />
            </td>
          </tr>
          <tr>
            <td>
              <p>{strings("descriptions.androidVersion")}</p>
            </td>
            <td>
              <TextField
                id="android-version"
                label={strings("descriptions.code")}
                type="text"
                value={androidVersion}
                onChange={(event) => setAndroidVersion(event.target.value)}
                margin="normal"
              />
            </td>
          </tr>
          <tr>
            <td>
              <p>{strings("descriptions.deeplinkBaseUrl")}</p>
            </td>
            <td>
              <TextField
                id="deeplink-url"
                label={strings("descriptions.url")}
                type="text"
                value={deeplinkBaseurl}
                onChange={(event) => setDeeplinkBaseurl(event.target.value)}
                margin="normal"
              />
            </td>
          </tr>
          <tr>
            <td>
              <Button
                variant="contained"
                color="primary"
                onClick={saveInformation}
              >
                {strings("descriptions.save")}
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default AppVersionTab;
